<template>
  <section id="company-all">
    <b-card>
      <b-card-body>
        <b-button
            variant="gradient-success"
            @click="addClick()"
        >
          {{ $t("Add company") }}
        </b-button>

        <v-data-table
            :headers="headers"
            :items="desserts"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn
                variant="gradient-success"
                @click="initialize"
            >
              Reset
            </v-btn>
          </template>
        </v-data-table>
      </b-card-body>
    </b-card>

  </section>

</template>
<script>
import {
  BCard, BCardBody, BButton,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import CompanyService from '../../services/company.service'

export default {
  components: {
    BButton,
    BCard,
    BCardBody,
  },
  data() {
    return {
      headers: [
        {
          text: 'عنوان',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        { text: 'تاریخ ایجاد', value: 'creationTime' },
        { text: 'تاریخ ویرایش', value: 'modificationTime' },
        { text: 'عملیات', value: 'actions', sortable: false },
      ],
      desserts: [],
    }
  },
  async created() {
    this.initialize()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
      // eslint-disable-next-line no-underscore-dangle
    },
  },
  methods: {
    initialize() {
      CompanyService.all().then(
          res => {
            if (res.status === 'success') {
              if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i <= res.result.data.length - 1; i++) {
                  this.desserts.push(res.result.data[i])
                }
              }
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
      )
    },
    addClick() {
      router.push({ path: '/company/add' })
    },

    deleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('Are you sure you want to delete this item?')) {
        CompanyService.delete({
          _id: this.desserts[index]._id,
        }).then(
            res => {
              if (res.status !== 'success') {
                alert(JSON.stringify((res)))
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'register error',
                    text: res.result,
                    icon: 'XIcon',
                    variant: 'danger',
                  },
                })
              } else {
                this.desserts.splice(index, 1)
              }
            },
            error => {
              this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'register error',
                  text: this.message,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            },
        )
      } else {
        index = ''
      }
      // Todo: Make this delete item from store
      // eslint-disable-next-line no-underscore-dangle
    },

  },
}
</script>
<style>
#company-all table thead tr {
  background: #f4f4f2;
}
#company-all table thead tr th{
  font-size: 1rem;
  color: azure;
  font-size: 0.9rem;
  color: #2b2b2b;
  font-weight: bold;
}
</style>
